/**
 * AreaAnalysisCard
 * 
 * @Author: Focci
 * @Date: 2023-08-11 17:20:55
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-11 17:20:55
 */

'use client'

// import PropTypes from 'prop-types'
import clsx from 'clsx'
import Table from '@comp/table'
import useApp from '@hook/useApp'
import { formatPrice } from '@lib/utils'
import { useTranslations } from 'next-intl'

function celRender(prop) {
  return function R({ row }) {
    return (
      <span className="text-f.7">
        {row[prop]}
      </span>
    )
  }
}

function getColumns(th) {
  return [
    {
      key: 'year',
      label: th('year'),
      render: celRender('year'),
    },
    {
      key: 'median',
      label: th('medianPrice'),
      render: ({ row }) => (
        <span className="text-f.7">
          {`$${formatPrice(row.median)}`}
        </span>
      )
    },
    {
      key: 'change',
      label: th('amplitude'),
      render: ({ row }) => (
        <span 
          className={clsx([
            'text-f.7', 
            row.change > 0 ? 'text-error' : 'text-success'
          ])}
        >
          {row.change ? `${row.change}%` : '-'}
        </span>
      )
    },
    {
      key: 'count',
      label: th('numberOfSales'),
      render: celRender('count'),
    },
  ]
}

export default function AreaAnalysisCard({
  data = []
}) {
  const { isMobile } = useApp()
  const th = useTranslations('house')
  const columns = getColumns(th)
  
  return (
    <Table
      zebra 
      data={data}
      columns={columns}
      height={isMobile ? 'auto' : '13.7rem'}
    />
  )
}

// AreaAnalysisCard.propTypes = {
//   className: PropTypes.string,
// }
